<template>
  <div class="package-bubble">
    <BubbleHeader>{{message.message_description}}</BubbleHeader>
    <template v-if="$hasPermission('can_view_payments')">
      <BubbleTextRow v-if="message.text"><BubbleTextMsg :text="message.text" /></BubbleTextRow>

      <MsgblContent :type="message.direction" v-if="message.showEntityLink">
        <MsgblLinkHeader icon="package"
                        :title="message.appointment_title"
                        @click="navigateTo" />
      </MsgblContent>

      <MsgblContent :type="message.direction" v-if="message.showEntityCard">
        <MsgblLinkHeader icon="package"
                        :title="message.appointment_title"
                        @click="navigateTo" />
        <MsgblActions v-if="packageActions.length"
                      :actions="packageActions"
                      @action="actionClicked" />
      </MsgblContent>

    </template>

    <MsgblNoAccess v-else
                   icon="package"
                   :direction="message.direction">
    </MsgblNoAccess>

  </div>
</template>

<script>
import {
  BubbleHeader,
  BubbleTextRow,
  BubbleTextMsg,
  MsgblNoAccess,
  MsgblActions,
  MsgblContent,
  MsgblLinkHeader,
} from './helpers'
import {paymentsStatusesService} from "@/modules/payments/services";

export default {
  name: 'PackageBubble',
  components: {
    MsgblActions,
    BubbleHeader,
    MsgblContent,
    BubbleTextMsg,
    BubbleTextRow,
    MsgblNoAccess,
    MsgblLinkHeader,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      allowedActions: ['take_payment', 'send_an_invoice', 'waive_payment', 'edit_payment_status', 'view_payment', 'view_payments', 'view_invoice'],
      paymentStatus: undefined,
    }
  },
  created() {
    this.$frontageApi.listen('fetch-package', this.fetchDataAfterUpdate);
    this.fetchPackageData()
  },
  destroyed() {
    this.$frontageApi.remove('fetch-package', this.fetchDataAfterUpdate);
  },
  computed: {
    clientPackage() {
      return this.message.messageable
    },
    packageActions() {
      let actions = []
      let that = this
      if (this.paymentStatus)
        this.paymentStatus.payment_status_actions.forEach(action => {
          if (that.allowedActions.includes(action.name))
            actions.push({name: action.name, name_h: action.caption})
        })
      return actions
    },
  },
  methods: {
    navigateTo() {
      this.$frontageApi.navigateTo('app.client-package.show', {uid: this.message.messageable.uid});
    },
    fetchDataAfterUpdate(data){
      if (data === this.paymentStatus.uid){
        this.fetchPackageData()
      }
    },
    async fetchPackageData() {
        try {
          const res = await paymentsStatusesService.get(this.clientPackage.payment_status_uid)
          this.paymentStatus = res.data
        } catch (e) {
          console.error('error', e);
        }
    },
    actionClicked({action}) {
      this.$frontageApi.send('client-package-bubble-action', {action, clientPackage: this.clientPackage, paymentStatus: this.paymentStatus})
    },
  }
}
</script>
